module.exports = __webpack_public_path__ + "static/img/home-icon6.9dbc9af1.png";